import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AbstractApi } from './abstract.api';
import { User } from './profil.api';

export function isAdmin(user: User | null) {
  if (user == null) {
    return false;
  }

  return (
    user.roles!.indexOf('ROLE_ADMIN') >= 0 ||
    user.roles!.indexOf('ROLE_SUPPORT') >= 0
  );
}

export interface UserList {
  count: number;
  data: User[];
}

@Injectable({
  providedIn: 'root',
})
export class UserApi extends AbstractApi {
  public getUsers(
    length = 20,
    offset = 0,
    search: string = '',
    order: string = 'lastname',
    direction: string = 'ASC',
    role: string = '',
  ): Promise<UserList> {
    return firstValueFrom(
      this.http.get<UserList>(`${this.backend}/api/v1/users`, {
        params: {
          length,
          offset,
          search,
          order,
          direction,
          role,
        },
      }),
    );
  }

  public postUser(user: User): Promise<User> {
    return firstValueFrom(
      this.http.post<User>(`${this.backend}/api/v1/users`, user),
    );
  }

  public patchUser(idUser: string, user: User): Promise<User> {
    return firstValueFrom(
      this.http.patch<User>(`${this.backend}/api/v1/users/${idUser}`, user),
    );
  }

  public getUser(idUser: string): Promise<User> {
    return firstValueFrom(
      this.http.get<User>(`${this.backend}/api/v1/users/${idUser}`),
    );
  }

  public deleteUser(idUser: string): Promise<User> {
    return firstValueFrom(
      this.http.delete<User>(`${this.backend}/api/v1/users/${idUser}`),
    );
  }
}
